import { apiUrl } from '../../../settings'

export const listAllAbstractUrl = () => {
  return apiUrl + '/abstract-list'
}

export const addAbstractUrl = () => {
  return apiUrl + '/abstract'
}
export const deleteAbstractUrl = () => {
  return apiUrl + '/abstract/delete'
}
export const updateAbstractUrl = () => {
  return apiUrl + '/abstract/update'
}